import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import './index.css';
import { ThemeProvider } from '@material-ui/styles';
import * as serviceWorker from './serviceWorker';
import Router from './routes/Router';
import AuthStore from './stores/authStore';
import OrgStore from './stores/orgStore';
import DataStore from './stores/dataStore';
import JoyrideStore from './stores/JoyrideStore';
import { BridgeProvider } from './stores/BridgeProvider';
import DealMapperStore from './stores/dealMapperStore';
import ErrorBoundary from './components/ErrorBoundary';
import { theme } from './theme';
import { ErrorAlertProvider } from './alerts/ErrorAlertProvider';
import StatusInterceptor from './alerts/StatusInterceptor';

require('dotenv').config();

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://c026605f258a4e8ba9938e4cb70beda8@sentry.io/1846752',
  });
  // Removes console logs from browser in production
  console.log = () => {};
}

// if (process.env.NODE_ENV !== 'production') {
//   const { whyDidYouUpdate } = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }

const favicon = document.getElementById('favicon');
if (!window.location.hostname.includes('dealmap')) {
  favicon.href = `${process.env.PUBLIC_URL}/faviconDev.ico`;
}

// AuthStore, OrgStore are singletons
const dataStore = new DataStore();
const dealMapperStore = new DealMapperStore();
const joyrideStore = new JoyrideStore();
ReactDOM.render(
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <ErrorAlertProvider>
        <StatusInterceptor />
        <BridgeProvider
          stores={{
            authStore: AuthStore,
            orgStore: OrgStore,
            dataStore,
            dealMapperStore,
            joyrideStore,
          }}
        >
          <Router />
        </BridgeProvider>
      </ErrorAlertProvider>
    </ThemeProvider>
  </ErrorBoundary>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
